import { StackView, Text } from '@planningcenter/tapestry-react';
import React from 'react';
import { Subheading } from '../ui/subheading.js';

const PeopleBlankState = () => (React.createElement(StackView, { grow: 1 },
    React.createElement(StackView, { alignItems: "center", axis: "horizontal", padding: 2, spacing: 1 },
        React.createElement(Subheading, null, "People selected")),
    React.createElement(StackView, { alignment: "center", grow: 1, maxHeight: 18, padding: 2 },
        React.createElement(Text, { color: "foreground", align: "center", size: 4 }, "Search teams above to add people to the chat."))));

export { PeopleBlankState };
//# sourceMappingURL=people_blank_state.js.map
